module.exports = __webpack_public_path__ + "img/hardwareRouter8.fc2533ed.png";